import { Collection } from "../Collection";
import { ApiMetadata } from "./ApiMetadata";
import { ApiMetadataCache } from "./ApiMetadataCache";

/**
 * This class exists to provide access to retrieve/remove endpoint/model metadata from the metadata cache, without
 * providing full access to the cache itself.
 */
export class ApiMetadataCacheAccessor {
    public static clear(endpoint: string) {
        ApiMetadataCache.clear(endpoint);
    }

    public static clearAll() {
        ApiMetadataCache.clearAll();
    }

    public static put(endpoint: string, metadata: ApiMetadata) {
        ApiMetadataCache.put(endpoint, metadata);
    }

    public static getCopy(): Collection<ApiMetadata> {
        return ApiMetadataCache.getCopy();
    }

    public static putAll(sourceCache: Collection<ApiMetadata>) {
        ApiMetadataCache.putAll(sourceCache);
    }

    public static isEmpty(): boolean {
        return ApiMetadataCache.isEmpty();
    }
}
